var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsNeedsImage171(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #dddede;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30,
    cy: 30,
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.67,31.09c.17-.25,.3-.55,.52-.75,.44-.41,1.13-.4,1.61-.03,.11,.08,.21,.18,.31,.28,1.92,1.91,3.83,3.83,5.74,5.74,.07,.07,.13,.16,.25,.3,.1-.13,.15-.23,.23-.31,5.2-5.2,10.39-10.39,15.59-15.59,.4-.4,.85-.63,1.43-.47,.92,.25,1.29,1.35,.69,2.1-.08,.09-.16,.18-.24,.27-5.54,5.54-11.08,11.08-16.62,16.62-.56,.56-1.15,.69-1.73,.35-.15-.08-.28-.2-.4-.32-2.29-2.29-4.58-4.57-6.86-6.87-.22-.22-.34-.53-.5-.8,0-.17,0-.35,0-.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsNeedsImage171);
export default __webpack_public_path__ + "static/media/UDS Needs Image-17 (1).3a0cf5df9096a85b4bfb0b789d5fc09e.svg";
export { ForwardRef as ReactComponent };